import Image from '@/components/ui/image'
import Row, { Content } from '../layout/row'
import { ApiPagePage } from '@/types/contentTypes'
import { DataBackground } from '~/types/components'

type SEO = {
	title: string
	description: string
	opengraph_image: {
		alternative_text: string
		url: string
	}
	slug: string
}

export default function PageHeader({
	content,
}: {
	content: ApiPagePage['attributes']
}) {
	const seo: SEO = content.seo
	const page_header_background: DataBackground['attributes'] = content.page_header_background
	return (
		<Row
			rowSettings={{
				full_width: true,
				after_row_spacing: 'small',
				vertical_spacing: 'large',
				title: 'Page Header',
				background: page_header_background,
			}}
		>
			{/* <Image
					image={{
						alternativeText: '',
						url:
							seo.opengraph_image?.url ??
							'/placeholder.svg?height=400&width=800',
					}}
					className="absolute inset-0 -z-10 h-full w-full object-cover"
				/> */}

			{/* <div
				aria-hidden="true"
				className="absolute -z-10 bg-gradient-to-tr from-primary/90 to-secondary/20 opacity-20"
			/> */}

			<Content>
				<div className="grow self-stretch px-6 pt-12 lg:px-8">
					<h2 className="text-5xl font-semibold tracking-tight text-background sm:text-7xl">
						{seo.title}
					</h2>
					<p className="mt-8 text-pretty text-lg font-medium text-background sm:text-xl/8">
						{seo.description}
					</p>
				</div>
			</Content>
		</Row>
	)
}
